/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// import axios from 'axios';
import $http from '../../plugins/axios';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

export const triggerProxyAssignmentForSpecialProgram = async (programId: string) => {
  const res = await $http.get(`assignProxyToCohortLearner/${programId}`);
  return res;
};

export const invokeGetProgramDetails = async (url: string) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const getLearnerGrade = async (url: string) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.get(url).then((response) => {
    res = response.data.AllGrade;
    return res;
  });
  return res;
};

// const downloadEdcastUrl = async (urlToDownloadSusbmission: string, programName: string) => {
//   console.log(`programName ${programName}`);
//   const myRequest = new Request(urlToDownloadSusbmission, {
//     method: 'GET',
//     headers: {
//       'X-Requested-By': 'XMLHttpRequest',
//       'Content-Type': 'application/json',
//     },
//     mode: 'no-cors',
//     cache: 'default',
//   });
//   // fetch(myRequest).then((response: any) => {
//   //   const fileURL = window.URL.createObjectURL(new Blob([response.data]));
//   //   const fileLink = document.createElement('a');
//   //   fileLink.href = fileURL;
//   //   fileLink.setAttribute('download', 'Ed-castUrl.csv');
//   //   document.body.appendChild(fileLink);

//   //   fileLink.click();
//   // });
//   fetch(myRequest).then((response: any) => {
//     const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
//     const fileLink = document.createElement('a');
//     fileLink.href = fileURL;
//     // fileLink.setAttribute('download', learnerSubmission);
//     // document.body.appendChild(fileLink);

//     // fileLink.click();
//     fileLink.download = 'EdcastUrl.csv';
//     fileLink.click();
//     URL.revokeObjectURL(fileLink.href);
//   });
// };

export const getEdcaseURL = async (programId: string, programName: string) => {
  try {
    console.log(`programName ${programName}`);
    let res;
    await $http.get(`/skill/edcast/${programId}`).then(async (response) => {
      // console.log(response.data.sys_settings);
      res = response.data;
      // await downloadEdcastUrl(res, programName);
      const fileLink = document.createElement('a');
      fileLink.href = res;
      // fileLink.setAttribute('download', learnerSubmission);
      // document.body.appendChild(fileLink);

      // fileLink.click();
      // fileLink.download = 'EdcastUrl.csv';
      fileLink.click();
      URL.revokeObjectURL(fileLink.href);
      return res;
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const uploadBulkParticipants = async (url: any, bulkTaskFile: any) => {
  try {
    const res = await fetch(`${url}`, {
      method: 'put',
      body: bulkTaskFile,
    });
    const uploadResponse = res;
    return uploadResponse;
  } catch (err) {
    console.error(err);
    return err;
  }
};

export const uploadEnvAccessUsers = async (url: any, bulkTaskFile: any) => {
  try {
    const res = await fetch(`${url}`, {
      method: 'put',
      body: bulkTaskFile,
    });
    const uploadResponse = res;
    return uploadResponse;
  } catch (err) {
    console.error(err);
    return err;
  }
};
export const uploadServiceLineSkillsGFEventID = async (url: any, bulkTaskFile: any) => {
  try {
    const res = await fetch(`${url}`, {
      method: 'put',
      body: bulkTaskFile,
    });
    const uploadResponse = res;
    return uploadResponse;
  } catch (err) {
    console.error(err);
    return err;
  }
};

export const updateBulkParticipants = async (bulkImportData: any) => {
  try {
    let updateRes;
    await $http.post('/program/proxy', bulkImportData).then((response: any) => {
      updateRes = response.data;
      return updateRes;
    });
    return updateRes;
  } catch (error) {
    return error;
  }
};
export const invokeTriggerReport = async (programId: any) => {
  try {
    let updateRes;
    await $http.get(`/program/report/${programId}`).then((response: any) => {
      updateRes = response.data;
      return updateRes;
    });
    return updateRes;
  } catch (error) {
    return error;
  }
};
